import ClipboardShareController from "./clipboard_share_controller"

// Copy / share the referral link (issues #497 + #496). All behaviour lives in
// the shared base; this subclass only fixes the `referral-share` identifier so
// the existing data-attributes (`data-referral-share-*`) keep working.
export default class extends ClipboardShareController {}
